import { takeLatest, put, select, delay } from 'redux-saga/effects'

import { modal } from 'store/entities/modal/actions'
import { setEditForm } from '../actions'
import { getValuesEditForm } from '../selectors'

export default function* postSaga() {
  yield takeLatest(modal.hide, handleSwitchForm)
}
// TODO: better to find another approach to avoid this realization
export function* handleSwitchForm() {
  const isEdit = yield select(getValuesEditForm)
  if (isEdit) {
    yield delay(405)
    yield put(setEditForm())
  }
}
